import { render, staticRenderFns } from "./HomePageHeroSingleIpo.vue?vue&type=template&id=6e726439"
import script from "./HomePageHeroSingleIpo.vue?vue&type=script&lang=js"
export * from "./HomePageHeroSingleIpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HomePageHeroSingleIpo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CImage: require('/vercel/path0/components/ui/c-image.vue').default,BaseButton: require('/vercel/path0/components/ui/BaseButton.vue').default})
